import React, { Fragment } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const MIN_VALUE = 1;
const MAX_VALUE = 10;
const NUM_STARS = 5;

class Star extends React.Component {
    render() {
        const {
            full,
            half,
            highlight,
            index,
            onMouseEnter,
            onMouseLeave,
            onClick
        } = this.props;

        const className = classNames(
            "star-rating__star",
            { "star-rating__star--highlight": highlight },
            { "star-rating__star--full": full },
            { "star-rating__star--half": half }
        );

        const leftValue = (MIN_VALUE + index) * 2 - MIN_VALUE;
        const rightValue = (MIN_VALUE + index) * 2;

        return (
            <span className={className}>
                <span
                    className="star-rating__star-left"
                    onMouseEnter={() => onMouseEnter(leftValue)}
                    onMouseLeave={onMouseLeave}
                    onClick={() => onClick(leftValue)}
                ></span>
                <span
                    className="star-rating__star-right"
                    onMouseEnter={() => onMouseEnter(rightValue)}
                    onMouseLeave={onMouseLeave}
                    onClick={() => onClick(rightValue)}
                ></span>
            </span>
        );
    }
}

Star.propTypes = {
    full: PropTypes.bool.isRequired,
    half: PropTypes.bool.isRequired,
    highlight: PropTypes.bool.isRequired,
    index: PropTypes.number.isRequired,
    onMouseEnter: PropTypes.func.isRequired,
    onMouseLeave: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired
};

export default class StarRating extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
            highLightedValue: null
        };
    }

    onMouseEnter(value) {
        const { isStatic } = this.props;
        if (isStatic) {
            return;
        }
        this.setState({ highLightedValue: value });
    }

    onMouseLeave() {
        const { isStatic } = this.props;
        if (isStatic) {
            return;
        }
        this.setState({ highLightedValue: null });
    }

    onClick(value) {
        const { onChange, isStatic } = this.props;
        if (isStatic) {
            return;
        }

        this.setState(
            {
                value: value,
                highLightedValue: null
            },
            onChange
        );
    }

    render() {
        const { value, highLightedValue } = this.state;
        const { htmlName, isStatic } = this.props;
        // highlighted value overrides the actual value because of mouse pointer
        // events
        let _value;
        if (!isStatic && highLightedValue !== null) {
            _value = highLightedValue;
        } else {
            _value = parseInt(value, 10);
        }

        const numFull = Math.floor((_value / MAX_VALUE) * NUM_STARS);
        const hasHalf = _value / (MAX_VALUE / NUM_STARS) > numFull;
        const numEmpty = Math.floor(NUM_STARS - numFull) - (hasHalf ? 1 : 0);

        const events = {
            onMouseEnter: this.onMouseEnter.bind(this),
            onMouseLeave: this.onMouseLeave.bind(this),
            onClick: this.onClick.bind(this)
        };

        let full = [];
        for (let i = 0; i < numFull; i++) {
            full.push(
                <Star
                    full={true}
                    half={false}
                    highlight={highLightedValue !== null}
                    key={i}
                    index={i}
                    {...events}
                />
            );
        }

        let empty = [];
        let i = hasHalf ? numFull + 1 : numFull;
        let maxI = i + numEmpty;
        for (i; i < maxI; i++) {
            empty.push(
                <Star
                    full={false}
                    half={false}
                    highlight={false}
                    key={i}
                    index={i}
                    {...events}
                />
            );
        }

        return (
            <Fragment>
                {isStatic ? null : (
                    <input
                        type="hidden"
                        name={htmlName}
                        value={value}
                        onChange={() => {}}
                    />
                )}

                {full}
                {hasHalf ? (
                    <Star
                        full={false}
                        half={true}
                        highlight={highLightedValue !== null}
                        index={numFull}
                        {...events}
                    />
                ) : null}
                {empty}
            </Fragment>
        );
    }
}

StarRating.propTypes = {
    value: PropTypes.string.isRequired,
    htmlName: PropTypes.string,
    isStatic: PropTypes.bool,
    onChange: PropTypes.func
};

StarRating.defaultProps = {
    htmlName: "",
    isStatic: false
};
